<div>
  @if (media.isActive('xs')) {
    <div>
      <mat-tab-group>
        <div *checkFeatureRender="'StudentSessionsView'">
          <mat-tab label="Today">
            <student-sessions-tile [sessionTileParams]="sessionTileParams" class="grid-secondary"></student-sessions-tile>
          </mat-tab>
        </div>
        <mat-tab label="Pending Actions" *checkFeatureRender="'ActionsView'">
          <actions-tile [actionDataParams]="actionDataParams" class="grid-primary" [displayall]="true"></actions-tile>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
  @if (! media.isActive('xs')) {
    <div>
      <div class="margin-top-50">
        <actions-tile [actionDataParams]="actionDataParams" class="grid-primary tile-padding-first" [displayall]="true" *checkFeatureRender="'ActionsView'"></actions-tile>
      </div>
      <div *checkFeatureRender="'StudentSessionsView'">
        <student-sessions-tile [sessionTileParams]="sessionTileParams" class="grid-secondary"></student-sessions-tile>
      </div>
    </div>
  }
</div>
